import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createPartnerSplitSupplyNotice,
  getPartnerSplitSupplyNotice,
  listPartnerSplitSupplyNotices,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 他社の通告値の追加 (空の登録を作る) mutation hook。 同じ条件の登録が既にある時は作らず、 既にある
 * 登録の id が `created = false` で返る。 成功したら一覧と詳細を最新化する。
 */
export function useCreatePartnerSplitSupplyNotice(): InvalidatingMutationResultFor<
  typeof createPartnerSplitSupplyNotice
> {
  return useInvalidatingMutation(createPartnerSplitSupplyNotice, [
    createConnectQueryKey({
      schema: listPartnerSplitSupplyNotices,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: getPartnerSplitSupplyNotice,
      cardinality: 'finite',
    }),
  ])
}
